import React, { useState } from 'react';
import { Button, ButtonGroup } from 'ui';
import AlertBox from 'components/shared/AlertBox';
import LinkButton from 'components/shared/LinkButton';
import CSRFForm from 'components/shared/CSRFForm';
import { routes } from 'constants/config';

const ArchiveConfirmation = ({ scenario, onDismiss }) => {
  const [loading, setLoading] = useState(false);

  return (
    <AlertBox onDismiss={loading ? null : onDismiss}>
      <CSRFForm
        url={routes.ON_DEMAND_PRACTICE.CREATOR.CONTAINER.ARCHIVE(
          scenario.practiceContainerId,
        )}
        onSubmit={() => setLoading(true)}
      >
        <h2 className="ff-ss mb-16">
          {t('practice.on_demand_practice.overview.archive.confirmation')}
        </h2>
        <ButtonGroup alignEnd>
          <LinkButton
            disabled={loading}
            type="primary"
            className="mr-8"
            onClick={onDismiss}
          >
            {t('common.cancel')}
          </LinkButton>
          <Button loading={loading} submit primary>
            {t('common.archive')}
          </Button>
        </ButtonGroup>
      </CSRFForm>
    </AlertBox>
  );
};
export default ArchiveConfirmation;
